/* src/app/warehousing/pages/products-label/products-label.component.scss */
/*# sourceMappingURL=products-label.component.css.map */
